import { CheckCircle2 } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const ENG_IMAGE =
  "https://images.pexels.com/photos/5203849/pexels-photo-5203849.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Engineering = () => {
  const { t } = useLang();

  return (
    <section
      id="engineering"
      data-testid="engineering-section"
      className="relative py-16 lg:py-20 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="relative border border-white/10 rounded-sm overflow-hidden aspect-[4/3]">
                <img
                  src={ENG_IMAGE}
                  alt="Fiber-optic infrastructure representing in-house engineering"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#0B0F19]/70 via-transparent to-[#00E5FF]/10" />
              </div>
              <div className="absolute -bottom-5 -right-5 hidden md:block border border-[#00E5FF]/40 bg-[#0B0F19]/95 backdrop-blur-md px-5 py-4 rounded-sm">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#00E5FF]">
                  In-house team
                </div>
                <div className="mt-1 text-white font-heading font-bold text-lg">
                  CNS · NAV · SUR
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 text-[#00E5FF] font-mono text-xs uppercase tracking-[0.24em]">
              <span className="w-6 h-px bg-[#00E5FF]" />
              {t.engineering.eyebrow}
            </div>
            <h2
              data-testid="engineering-title"
              className="mt-5 font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight"
            >
              {t.engineering.title}
            </h2>

            <div className="mt-6 space-y-4 text-slate-300 text-base leading-relaxed">
              {t.engineering.paragraphs.map((p, i) => (
                <p key={i} data-testid={`engineering-paragraph-${i}`}>
                  {p}
                </p>
              ))}
            </div>

            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {t.engineering.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`engineering-bullet-${i}`}
                  className="flex items-start gap-3 border border-white/10 bg-white/[0.02] p-4 rounded-sm hover:border-[#00E5FF]/30 transition-colors duration-300"
                >
                  <CheckCircle2
                    size={18}
                    strokeWidth={1.5}
                    className="text-[#00E5FF] shrink-0 mt-0.5"
                  />
                  <span className="text-sm text-slate-200 leading-relaxed">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Engineering;
